enum FarmCardTabs {
  DESCRIPTION = 'description',
  WORKING_TIME = 'working_time',
  DELIVERY = 'delivery',
  GALLERY = 'gallery',
  CONTACTS = 'contacts',
  PARTNERS = 'partners',
}

export default FarmCardTabs;
